import { User } from '../store/Users/UserModels';

/**
 * Get initials from a `User`s first and last name.
 * @param {User} user - a user with `firstName` and `lastName` properties
 * @return {String} the first and last initials
 */
export default function toInitials({ firstName, lastName }: Partial<User>): string {
  return `${(firstName || '?')[0]}${(lastName || '?')[0]}`;
};